import  { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Notification from '../shared/Notification';
import styles from './login.module.css';
import NavHeader from './NavHeader';


const LoginApplicant = () => {
    const [error, setError] = useState('');
    const [notification, setNotification] = useState('');
    const [formData, setFormData] = useState({
        emailOrPhone: '',
        password: ''
    });
    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();
    
    useEffect(() => {
        const message = localStorage.getItem('notification');
        if (message) {
            setNotification(message);
            localStorage.removeItem('notification');
        }
        if (localStorage.getItem('token')) {
            navigate('/home');
        }
    }, []);

    const handleCloseNotification = () => {
        setNotification('');
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/api/authApplicant/login', formData);
            // console.log(response.data);
            // console.log(response.data.message);
            const { token } = response.data;
            localStorage.setItem('token', token);
            localStorage.setItem('notification', 'Successfully LoggedIn !');
            navigate('/home');
            
        } catch (error) {
            const Message = error.response.data.message;
            // console.log('Message:',Message);
            // console.error('error1:',error);
            const errorMessage2 = error.response?.data?.message || 'An error occurred';
            setError(errorMessage2);
        }
    }

    return (
        <>
        <NavHeader/>
        {notification && (
            <Notification message={notification} onClose={handleCloseNotification} />
        )}
        <div className={styles.loginContainer}>
            <form onSubmit={handleSubmit}  className={styles.loginForm}>
                <h2>Login as Applicant</h2>
                <div className={styles.enterPasswordContainer}>
                    <input
                        type="text"
                        name="emailOrPhone"
                        placeholder="Email or Phone"
                        value={formData.emailOrPhone}
                        className={styles.emailOrPhoneInput}
                        onChange={handleChange}
                        required
                    />
                    <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Password"
                        value={formData.password}
                        className={styles.passwordInput}
                        onChange={handleChange}
                        required
                    />
                    <span 
                        onClick={() => setShowPassword(!showPassword)}
                        className={styles.eyeIcon}
                    >
                    {showPassword ? '👁️' : '👁️‍🗨️'}
                    </span>
                </div>
                {error && (
                <div className={styles.errorMessage}>
                    <p>{error}</p>
                </div>
                )}
                <button type="submit" >Login</button>
                <p>Don't have an account? <a href="/signup">Signup</a></p>
                <p><a href='/forget-password'>Forgot Password?</a></p>
            </form>
        </div>
        </>
    );
};

export default LoginApplicant;